import { TravelCompany } from '../../lib/types/models/travel-company/travel-company'
import { TravelCompanyInput } from '../../lib/types/models/travel-company/travel-company-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createTravelCompany(data: TravelCompanyInput) {
  return restApiClient
    .url(constructApiUrl(API.travelCompanies.create.url, null))
    .post<TravelCompany>(data)
}
